import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import {
  BonusSummary,
  BonusHistory,
  BonusWithdrawalRequest,
  BonusWithdrawalResponse
} from '../models';

/**
 * Bonus Service for IH API
 * Handles bonus and cashback operations
 */
@Injectable({
  providedIn: 'root'
})
export class BonusService extends BaseHttpService {
  private readonly BONUS_ENDPOINT = 'bonus';

  /**
   * Get bonus summary
   * GET /api/ih/bonus/summary/{phone}
   */
  getBonusSummary(phone: string): Observable<BonusSummary> {
    return this.get<BonusSummary>(`${this.BONUS_ENDPOINT}/summary/${phone}`);
  }

  /**
   * Get bonus history
   * GET /api/ih/bonus/history/{phone}
   */
  getBonusHistory(phone: string): Observable<BonusHistory[]> {
    return this.get<BonusHistory[]>(`${this.BONUS_ENDPOINT}/history/${phone}`);
  }

  /**
   * Get bonus history by policy
   * GET /api/ih/bonus/history/{phone}/{policyNo}
   */
  getBonusHistoryByPolicy(phone: string, policyNo: string): Observable<BonusHistory[]> {
    return this.get<BonusHistory[]>(`${this.BONUS_ENDPOINT}/history/${phone}/${policyNo}`);
  }

  /**
   * Submit bonus withdrawal request
   * POST /api/ih/bonus/withdrawal
   */
  submitWithdrawal(request: BonusWithdrawalRequest): Observable<BonusWithdrawalResponse> {
    return this.post<BonusWithdrawalResponse>(`${this.BONUS_ENDPOINT}/withdrawal`, request);
  }

  /**
   * Get withdrawal history
   * GET /api/ih/bonus/withdrawal-history/{phone}
   */
  getWithdrawalHistory(phone: string): Observable<BonusHistory[]> {
    return this.get<BonusHistory[]>(`${this.BONUS_ENDPOINT}/withdrawal-history/${phone}`);
  }

  /**
   * Get available bonus amount
   * GET /api/ih/bonus/available/{phone}/{policyNo}
   */
  getAvailableBonus(phone: string, policyNo: string): Observable<number> {
    return this.getRaw<number>(`${this.BONUS_ENDPOINT}/available/${phone}/${policyNo}`);
  }
}
